module.exports = __webpack_public_path__ + "img/9788963860145.9fc7119f.jpg";